var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7012 9.00006C29.7012 9.00006 29.4082 6.9317 28.5059 6.0235C27.3633 4.82819 26.0859 4.82233 25.5 4.75201C21.3047 4.44733 15.0059 4.44733 15.0059 4.44733H14.9941C14.9941 4.44733 8.69531 4.44733 4.5 4.75201C3.91406 4.82233 2.63672 4.82819 1.49414 6.0235C0.591797 6.9317 0.304688 9.00006 0.304688 9.00006C0.304688 9.00006 0 11.4317 0 13.8575V16.1309C0 18.5567 0.298828 20.9883 0.298828 20.9883C0.298828 20.9883 0.591797 23.0567 1.48828 23.9649C2.63086 25.1602 4.13086 25.1192 4.79883 25.2481C7.20117 25.4766 15 25.5469 15 25.5469C15 25.5469 21.3047 25.5352 25.5 25.2364C26.0859 25.1661 27.3633 25.1602 28.5059 23.9649C29.4082 23.0567 29.7012 20.9883 29.7012 20.9883C29.7012 20.9883 30 18.5626 30 16.1309V13.8575C30 11.4317 29.7012 9.00006 29.7012 9.00006ZM11.9004 18.8907V10.459L20.0039 14.6895L11.9004 18.8907Z",
    fill: "#B0B0B0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon_youtube.044b2702f71eaf0c4943ecb68b9b1262.svg";
export { ForwardRef as ReactComponent };